import {CellRendererName} from "@/components/Roster/Pages/RosterAthletes/Objects/CellRendererName";
import omit from "lodash/omit";
import {editableCheck} from "../staticAthleteColumnsDefinitions";

export class ColumnDefinition {

    constructor(name, header, renderer = null, required = false, example = '', options = {}) {
        this.name = name;
        this.header = header;
        this.renderer = renderer;
        this.required = required;
        this.example = example;
        this.options = options;
    }

    static fromSportField(sportField, requiredFields = [], athletes = []) {
        const name = sportField.field_name;
        const required = requiredFields.includes(name);
        const header = `${sportField.field_label}${required ? ' *' : ''}`;
        const renderer = CellRendererName.from(sportField.field_name);
        const options = { headerComponent: 'DefaultHeader', minWidth: 180, editable: (params) => editableCheck( params.data.id, name, athletes) };
        const example = sportField.example || sportField.placeholder;

        return new ColumnDefinition(
            name,
            header,
            renderer,
            required,
            example,
            options
        );
    }

    static fromRaw(object) {
        return new ColumnDefinition(
            object.field,
            object.headerName,
            CellRendererName.from(object.cellRenderer),
            object.headerName?.endsWith('*'),
            object.example,
            omit(object, ['field', 'headerName', 'cellRenderer'])
        );
    }

    toEditableColumn() {
        return {
            example: this.example,
            field: this.name,
            headerName: this.header,
            cellRenderer: this.renderer.name,
            ...this.options
        }
    }

    toPreviewColumn() {
        return {
            field: this.name,
            headerName: (this.header.endsWith('*') ? this.header.slice(0, -1) : this.header).trim(),
        }
    }
}